import { render } from "./iconDice.vue?vue&type=template&id=55048030&scoped=true"
import script from "./iconDice.vue?vue&type=script&lang=js"
export * from "./iconDice.vue?vue&type=script&lang=js"

import "./iconDice.vue?vue&type=style&index=0&id=55048030&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-55048030"

export default script